<div class="container-fluid">
  <!--<div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>-->

  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-chart-line mr-2"></i>Phân tích tài khoản
  </h1>

  <!-- Description -->
  <p class="lead">Mô-đun Phân tích Tài khoản cung cấp các biểu diễn trực quan về thu nhập và chi phí của bạn, cho phép bạn dễ dàng theo dõi và phân tích dữ liệu tài chính của mình.</p>

  <!-- DataTales Example -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="incomes"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>

      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="expenses"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel1"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>
    </div>
  </div>
</div>

